define('modules/lp_integration/views/fields_step_empty_view',['require','exports','module','base/itemview','ldsh!../templates/fields_step_empty_view'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/fields_step_empty_view")
  });
});

